import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-request-approvement',
  templateUrl: './modal-request-approvement.component.html',
  styleUrls: ['./modal-request-approvement.component.scss']
})
export class ModalRequestApprovementComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  //functions
  dismiss(data?) {
    this.dialogRef.close((data || null));
  }

  submitForm() {
    console.log('submit');
  }
}
